import React from "react";
import { useHistory } from "react-router-dom";

const Redirection: React.FC = () => {
  const history = useHistory();
  const queryParam = new URLSearchParams(history.location.search);
  const fi = queryParam.get("fi");
  const reqdate = queryParam.get("resdate");
  const ecreq = queryParam.get("ecres");

  return (
    <div>
      fi: {fi}, resdate: {reqdate}, ecres: {ecreq}
    </div>
  );
};

export default Redirection;
